<template>
  <normal-dialog
    :title="type ? '编辑' : '新增'"
    :visible="visible"
    :before-close="resetDialog"
    @update:visible="updateVisibleHandle"
    class="OtherRate-EditDialog"
    width="720px"
  >
    <el-form
      :disabled="loading"
      label-width="100px"
      :inline="true"
    >
      <el-form-item label="所属区域">
        <span v-if="type">{{selected.campusName}}</span>
        <area-select
          v-else
          ref="areaSelect"
          v-model="selected.campusId"
          @change="areaChangeHandle"
          clearable
        />
      </el-form-item>
      <el-form-item label="费率名称">
        <el-input
          v-model="selected.name"
          :maxLength="60"
          clearable
        />
      </el-form-item>
      <el-form-item label="服务类型">
        <span v-if="type">{{getServiceTypeName(selected.serviceType)}}</span>
        <ServiceTypeSelect
          v-else
          v-model="selected.serviceType"
          clearable
        />
      </el-form-item>
      <el-form-item label="设备型号">
        <span v-if="type">{{getDeviceModelName(selected.deviceModelId)}}</span>
        <DeviceModelSelect
          v-else
          v-model="selected.deviceModelId"
          @change="deviceModelIdChangeHandle"
          clearable
        />
      </el-form-item>
    </el-form>

    <form-area title="费率配置">
      <div
        v-if="selected.rates.length"
        class="function-table"
      >
        <div class="function-table-row header">
          <div class="function-table-col"></div>
          <div class="function-table-col">功能名称</div>
          <div class="function-table-col">自定义功能名称</div>
          <div class="function-table-col">功能定价/元</div>
          <div class="function-table-col">时长/min</div>
          <div
            v-if="selected.rates[0] && selected.rates[0].pulsesIsShow"
            class="function-table-col"
          >脉冲数</div>
        </div>
        <div
          class="function-table-row"
          v-for="(item, index) in selected.rates"
          :key="index"
        >
          <div class="function-table-col">
            <el-checkbox v-model="item.checked" />
          </div>
          <div class="function-table-col">
            {{item.name}}
          </div>
          <div class="function-table-col">
            <el-input v-model="item.modelName" />
          </div>
          <div class="function-table-col">
            <el-input-number
              :controls="false"
              :min="0"
              :max="999.99"
              :precision='2'
              v-model="item.price"
            />
          </div>
          <div class="function-table-col">
            <el-input-number
              :controls="false"
              :min="0"
              :max="999"
              :precision='0'
              v-model="item.duration"
            />
          </div>
          <div
            v-if="item.pulsesIsShow"
            class="function-table-col"
          >
            <el-input-number
              :controls="false"
              :min="0"
              :max="999"
              :precision='0'
              v-model="item.pulsesNum"
            />
          </div>
        </div>
      </div>
    </form-area>

    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="resetDialog">取 消</el-button>
      <el-button
        type="primary"
        @click="submitUpdateHandle"
      >确 定</el-button>
    </div>
  </normal-dialog>
</template>

<script>
const dialogMixin = manageShell.default.mixinModule.Dialog;
import { mapGetters, mapActions } from 'vuex';
import ServiceTypeSelect, {
  serviceTypeMixin,
} from '../../components/ServiceTypeSelect/index';
import DeviceModelSelect, {
  deviceModelMixin,
} from '../../components/DeviceModelSelect/index';

export default {
  props: {
    getRateListByModel: { type: Function },
  },
  mixins: [dialogMixin, serviceTypeMixin, deviceModelMixin],
  components: { ServiceTypeSelect, DeviceModelSelect },
  methods: {
    areaChangeHandle(val) {
      this.selected.campusName = this.$refs.areaSelect.getAreaName(val);
    },
    deviceModelIdChangeHandle(val) {
      console.log(val);
      if (val) {
        this.getRateListByModel({
          deviceModelId: val,
        });
      } else {
        this.selected.rates = [];
      }
    },
  },
};
</script>

<style lang="scss">
.OtherRate-EditDialog {
  .el-form-item {
    width: 302px;
  }
  .function-table {
    &.detail {
      text-align: center;
    }
    .function-table-row {
      display: flex;
      margin-bottom: 12px;
      &.header {
        text-align: center;
      }
      .function-table-col {
        margin-left: 12px;
        width: 150px;
        &:first-child {
          width: 50px;
          margin-left: 0;
          text-align: center;
        }
        .el-input-number {
          width: 100%;
        }
      }
    }
  }
}
</style>
